import React, {
    CSSProperties,
    forwardRef,
    Fragment,
    Ref,
    useContext,
    useEffect,
    useImperativeHandle,
    useRef,
    useState
} from "react";
import {
    AsyncTypeahead,
    AsyncTypeaheadProps,
    TypeaheadModel,
    Menu,
    MenuItem,
    Highlighter
} from "react-bootstrap-typeahead";
import { AppContext } from "../../app-context";
import AppInputStyles from "../app-input/AppInput.module.scss";
import FlatInputStyles from "../flat-input/FlatInput.module.scss";
import HelperStyles from "../../scss/helper.module.scss";
import "./Search.scss";
import { CitySearchResultWithCateg } from "../../custom-types/location-search";
import { GenericObject } from "../../custom-types/generic-object";
import MapPinAltIcon from "../../icons/MapPinAlt.svg";
import RecentGreyIcon from "../../icons/RecentGrey.svg";
import MapPinGreyIcon from "../../icons/MapPinGrey.svg";
import CloseCircleIcon from "../../icons/CloseCircle.svg";
import { getCurrentState } from "../../methods/getCurrentState";
import { getRemValue } from "../../methods/getRemValue";
import { FONT_WEIGHTS } from "../../constants/misc";
import { groupBy } from "../../methods/groupBy";
import classNames from "classnames";

const renderMenu: AsyncTypeaheadProps<CitySearchResultWithCateg>["renderMenu"] = (results, menuProps, state) => {
    let index = (menuProps as any).showClearOption ? 1 : 0;
    const groupedResults = groupBy(results, "category");
    return (
        <Menu {...menuProps}>
            {(menuProps as any).showClearOption && (
                <MenuItem
                    option={{ name: "Clear Search", category: "clear" }}
                    position={0}
                    style={{
                        // color: "#1053FF",
                        color: "#202124",
                        fontSize: getRemValue(16),
                        letterSpacing: getRemValue(-0.16),
                        fontWeight: FONT_WEIGHTS.bold,
                        display: "flex",
                        alignItems: "center"
                    }}
                >
                    <span
                        style={{
                            marginRight: "16px",
                            // backgroundColor: "#1053FF",
                            backgroundColor: "#F9FAFB",
                            borderRadius: "50%",
                            // padding: `0px ${(22 - (18 / 48) * 22) / 2}px`
                            // height: "38px",
                            // width: "38.79px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            opacity: 0.5
                        }}
                    >
                        <CloseCircleIcon height={38} width={38} />
                    </span>{" "}
                    Clear Search
                </MenuItem>
            )}
            {groupedResults.map((res, i) => {
                switch (res.key) {
                    case "currentLoc":
                        return (
                            <Fragment key={i}>
                                {res.items.map((item, j) => {
                                    const menuItem = (
                                        <MenuItem
                                            key={j}
                                            option={item}
                                            position={index}
                                            style={{
                                                color: "#1053FF",
                                                fontSize: getRemValue(16),
                                                letterSpacing: getRemValue(-0.16),
                                                fontWeight: FONT_WEIGHTS.bold,
                                                display: "flex",
                                                alignItems: "center"
                                            }}
                                            onClick={(menuProps as any)._onClickItem}
                                        >
                                            <span
                                                style={{
                                                    marginRight: "16px",
                                                    backgroundColor: "#1053FF",
                                                    borderRadius: "50%",
                                                    // padding: `0px ${(22 - (18 / 48) * 22) / 2}px`
                                                    height: "38px",
                                                    width: "38.79px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center"
                                                }}
                                            >
                                                <MapPinAltIcon
                                                    height={15.83}
                                                    width={14.25} /* height={(20 / 48) * 22} width={(18 / 48) * 22} */
                                                />
                                            </span>
                                            {item.name}
                                        </MenuItem>
                                    );
                                    index++;
                                    return menuItem;
                                })}
                            </Fragment>
                        );
                    case "recent":
                        return (
                            <Fragment key={i}>
                                {/* <Menu.Header
                                        style={{
                                            marginTop: getHeightByViewPort(32),
                                            color: "#202124",
                                            fontWeight: FONT_WEIGHTS.bold,
                                            fontSize: getRemValue(12),
                                            padding: "0 20px"
                                        }}
                                    >
                                        {res.categoryLabel}
                                    </Menu.Header> */}
                                {res.items.map((item, i) => {
                                    const menuItem = (
                                        <MenuItem
                                            key={i}
                                            option={item}
                                            position={index}
                                            style={{
                                                color: "#202124",
                                                width: "max-content",
                                                fontSize: getRemValue(16),
                                                letterSpacing: getRemValue(-0.16),
                                                fontWeight: FONT_WEIGHTS.normal,
                                                display: "flex",
                                                alignItems: "center"
                                            }}
                                            onClick={(menuProps as any)._onClickItem}
                                        >
                                            {res.key === "recent" && (
                                                <span
                                                    style={{
                                                        marginRight: "16px",
                                                        borderRadius: "50%",
                                                        // padding: `0px ${(22 - (18 / 48) * 22) / 2}px`,
                                                        backgroundColor: "#F9FAFB",
                                                        border: "1px solid #E6E6E6",
                                                        height: "38px",
                                                        width: "38.79px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center"
                                                    }}
                                                >
                                                    <RecentGreyIcon
                                                        height={14.25}
                                                        width={
                                                            14.61
                                                        } /* height={(18 / 48) * 22} width={(18 / 48) * 22} */
                                                    />
                                                </span>
                                            )}
                                            {menuProps.labelKey?.(item)}
                                        </MenuItem>
                                    );
                                    index++;
                                    return menuItem;
                                })}
                            </Fragment>
                        );
                    case "suggested":
                        return (
                            <Fragment key={i}>
                                {/* <Menu.Header
                                        style={{
                                            marginTop: getHeightByViewPort(32),
                                            color: "#202124",
                                            fontWeight: FONT_WEIGHTS.bold,
                                            fontSize: getRemValue(12),
                                            padding: "0 20px"
                                        }}
                                    >
                                        {res.categoryLabel}
                                    </Menu.Header> */}
                                {res.items.map((item, i) => {
                                    const menuItem = (
                                        <MenuItem
                                            key={i}
                                            option={item}
                                            position={index}
                                            style={{
                                                color: "#202124",
                                                fontSize: getRemValue(16),
                                                letterSpacing: getRemValue(-0.16),
                                                fontWeight: FONT_WEIGHTS.normal,
                                                display: "flex",
                                                alignItems: "center"
                                            }}
                                            onClick={(menuProps as any)._onClickItem}
                                        >
                                            {res.key === "suggested" && (
                                                <span
                                                    style={{
                                                        marginRight: "16px",
                                                        borderRadius: "50%",
                                                        // padding: `0px ${(22 - (18 / 48) * 22) / 2}px`,
                                                        backgroundColor: "#F9FAFB",
                                                        border: "1px solid #E6E6E6",
                                                        height: "38px",
                                                        width: "38.79px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center"
                                                    }}
                                                >
                                                    <MapPinGreyIcon />
                                                </span>
                                            )}
                                            {menuProps.labelKey?.(item)}
                                        </MenuItem>
                                    );
                                    index++;
                                    return menuItem;
                                })}
                            </Fragment>
                        );
                    default:
                        return (
                            <Fragment key={i}>
                                {res.items.map((item, i) => {
                                    const menuItem = (
                                        <MenuItem
                                            key={i}
                                            option={item}
                                            position={index}
                                            style={{
                                                // color: "#202124",
                                                width: "max-content",
                                                fontSize: getRemValue(16),
                                                letterSpacing: getRemValue(-0.16),
                                                fontWeight: FONT_WEIGHTS.normal,
                                                display: "flex",
                                                alignItems: "center"
                                            }}
                                            onClick={(menuProps as any)._onClickItem}
                                        >
                                            <span
                                                style={{
                                                    marginRight: "16px",
                                                    borderRadius: "50%",
                                                    // padding: `0px ${(22 - (18 / 48) * 22) / 2}px`,
                                                    backgroundColor: "#F9FAFB",
                                                    border: "1px solid #E6E6E6",
                                                    height: "38px",
                                                    width: "38.79px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center"
                                                }}
                                            >
                                                <MapPinGreyIcon />
                                            </span>
                                            <Highlighter search={state.text}>
                                                {menuProps.labelKey?.(item) ? menuProps.labelKey?.(item) : item.name}
                                            </Highlighter>
                                        </MenuItem>
                                    );
                                    index++;
                                    return menuItem;
                                })}
                            </Fragment>
                        );
                }
            })}
        </Menu>
    );
};

export interface SearchRef {
    focus: () => void;
}

export interface SearchProps<T extends TypeaheadModel> {
    isLoading: boolean;
    options: AsyncTypeaheadProps<T>["options"];
    onSearch: AsyncTypeaheadProps<T>["onSearch"];
    searchText: AsyncTypeaheadProps<T>["searchText"];
    onSelectItem: AsyncTypeaheadProps<T>["onChange"];
    selectedItem?: T;
    onInputChange?: AsyncTypeaheadProps<T>["onInputChange"];
    onFocus?: () => void;
    id: AsyncTypeaheadProps<T>["id"];
    onBlur?: AsyncTypeaheadProps<T>["onBlur"];
    labelText?: string;
    containerStyles?: CSSProperties;
    containerClassName?: string;
    labelStyles?: CSSProperties;
    inputWrapperStyles?: CSSProperties;
    inputWrapperClassName?: string;
    inputStyles?: CSSProperties;
    isRequired?: boolean;
    isValid?: boolean;
    alignment?: "left" | "right";
    setFocus?: number;
    labelKey?: AsyncTypeaheadProps<T>["labelKey"];
    placeholder?: string;
    placeholderClassName?: string;
    clear?: number;
    showClearBtn?: boolean;
    showClearOption?: boolean;
    prefix?: React.ReactNode;
    prefixClassName?: string;
    minLength?: number;
    labelClassName?: string;
    inputClassName?: string;
    activeClassName?: string;
    dirtyClassName?: string;
    isFlatInput?: boolean;
    maxLength?: number;
    disabled?: boolean;
}

const Search = forwardRef(
    <T extends GenericObject>(
        {
            isLoading,
            options,
            onSearch,
            searchText,
            onSelectItem,
            selectedItem,
            onInputChange,
            id,
            onFocus,
            onBlur,
            labelText,
            containerStyles,
            containerClassName,
            labelStyles,
            inputWrapperStyles,
            inputWrapperClassName,
            inputStyles,
            isRequired = false,
            isValid = true,
            alignment,
            setFocus,
            labelKey,
            placeholder,
            clear,
            showClearBtn,
            showClearOption,
            prefix,
            prefixClassName,
            minLength = 1,
            labelClassName,
            inputClassName,
            activeClassName,
            dirtyClassName,
            isFlatInput,
            maxLength = 25,
            disabled
        }: SearchProps<T>,
        forwardedRef: Ref<SearchRef>
    ) => {
        const typeaheadRef = useRef<any>(null);
        const { isMobile } = useContext(AppContext);
        const [isActive, setIsActive] = useState(false);
        const [isDirty, setIsDirty] = useState(false);

        const [currInputVal, setCurrInputVal] = useState("");

        const _onInputChange: AsyncTypeaheadProps<T>["onInputChange"] = (input, e) => {
            setCurrInputVal(input);
            onInputChange?.(input, e);
            if (!input) {
                onSelectItem?.([]);
                typeaheadRef.current?.clear();
                // typeaheadRef.current?.blur();
            }
        };

        const _onFocus = () => {
            typeaheadRef.current.inputNode.select();
            setIsActive(true);
            onFocus?.();
        };

        const _onBlur: AsyncTypeaheadProps<T>["onBlur"] = (e) => {
            // e.persist();
            setIsDirty(!!(e.target as any).value);
            setIsActive(false);
            onBlur?.(e);
            setCurrInputVal("");
            typeaheadRef.current.toggleMenu();
            // typeaheadRef.current.getInput().value = searchText;
        };

        const _onSelectItem: AsyncTypeaheadProps<T>["onChange"] = async (selected) => {
            if (selected[0]?.category === "clear") {
                onSelectItem?.([]);
                typeaheadRef.current?.clear();
                return;
            }
            const currInputVal = await getCurrentState(setCurrInputVal);
            if (!currInputVal) {
                onSelectItem?.(selected);
                typeaheadRef.current?.blur();
            }
        };
        const onKeyDown = (e: any) => {
            if (e.key === "Enter") {
                setCurrInputVal("");
            }
        };

        const _onClickItem = () => {
            setCurrInputVal("");
        };

        const focus = () => {
            typeaheadRef.current?.focus();
        };

        useImperativeHandle(forwardedRef, () => ({
            focus
        }));

        useEffect(() => {
            if (setFocus) {
                typeaheadRef.current?.focus();
            }
        }, [setFocus]);

        useEffect(() => {
            if (!clear) {
                return;
            }
            typeaheadRef.current?.clear();
        }, [clear]);

        useEffect(() => {
            if (selectedItem) {
                setIsDirty(true);
            } else {
                setIsDirty(false);
            }
        }, [selectedItem]);

        return (
            <div
                style={containerStyles}
                // className={classNames(
                //     HelperStyles.center_vertical +
                //         " " +
                //         AppInputStyles.field_group +
                //         " " +
                //         (isActive ? AppInputStyles.active : "") +
                //         " " +
                //         (isDirty && !isValid ? AppInputStyles.invalid : ""),
                //     containerClassName
                // )}
                className={classNames(
                    HelperStyles.center_vertical,
                    AppInputStyles.field_group,
                    isActive && AppInputStyles.active,
                    isActive && activeClassName,
                    isDirty && !isValid && AppInputStyles.invalid,
                    containerClassName,
                    isFlatInput && isActive && FlatInputStyles.active,
                    isFlatInput && FlatInputStyles.inputContainer
                )}
            >
                <label
                    htmlFor={id?.toString()}
                    // className={classNames(
                    //     isActive ? AppInputStyles.active : isDirty ? AppInputStyles.dirty : "",
                    //     labelClassName,
                    // )}

                    className={classNames(
                        isFlatInput && FlatInputStyles.label,
                        isActive
                            ? AppInputStyles.active +
                                  " " +
                                  (isFlatInput ? FlatInputStyles.active : "") +
                                  " " +
                                  activeClassName
                            : isDirty
                            ? AppInputStyles.dirty +
                              " " +
                              (isFlatInput ? FlatInputStyles.dirty : "") +
                              " " +
                              dirtyClassName
                            : "",
                        labelClassName
                    )}
                    style={labelStyles}
                >
                    {labelText}
                    {isRequired && <span className={"required"}>*</span>}
                </label>
                <div
                    style={{ ...inputWrapperStyles }}
                    className={
                        AppInputStyles.input_wrapper +
                        " " +
                        (isFlatInput ? FlatInputStyles.inputWrapper : "") +
                        " " +
                        inputWrapperClassName
                    }
                >
                    <div className={prefixClassName}>{prefix}</div>
                    <div
                        className={classNames(
                            AppInputStyles.input +
                                " " +
                                (isFlatInput ? FlatInputStyles.input : "") +
                                +(alignment === "right" && "right_aligned"),
                            inputClassName
                        )}
                        style={inputStyles}
                    >
                        <AsyncTypeahead
                            disabled={disabled}
                            open={isMobile ? true : undefined}
                            ref={typeaheadRef}
                            isLoading={isLoading}
                            options={options}
                            onSearch={onSearch}
                            searchText={searchText}
                            onChange={_onSelectItem}
                            selected={selectedItem && !currInputVal ? [selectedItem] : []}
                            delay={400}
                            minLength={minLength}
                            useCache
                            // clearButton
                            id={id}
                            onFocus={_onFocus}
                            onInputChange={_onInputChange}
                            onBlur={_onBlur}
                            labelKey={labelKey}
                            placeholder={placeholder}
                            renderMenu={(results, menuProps, state) => {
                                return renderMenu?.(
                                    currInputVal ? results : (options as any),
                                    {
                                        ...menuProps,
                                        labelKey,
                                        _onClickItem,
                                        showClearOption
                                    } as any,
                                    state as any
                                );
                            }}
                            inputProps={{
                                autoComplete: "new-password",
                                shouldSelectHint: (shouldSelect, event) => event.key === "Enter" || shouldSelect,
                                maxLength: maxLength,
                                id: String(id ?? "")
                            }}
                            caseSensitive={false}
                            filterBy={() => true}
                            onKeyDown={onKeyDown}
                            // clearButton={showClearBtn}
                        >
                            {({ onClear, selected }: any) => (
                                <div className="rbt-aux">
                                    {!!selected.length && showClearBtn && (
                                        <CloseCircleIcon onClick={onClear} style={{ cursor: "pointer" }} />
                                    )}
                                </div>
                            )}
                        </AsyncTypeahead>
                    </div>
                </div>
            </div>
        );
    }
);

export default Search;
